import React, { useState } from 'react'
import Truncate from 'components/shared/Truncate'
import cx from 'classnames'
import Icon from 'components/shared/Icon'
import TealToolTip from 'components/TealToolTip'
import { AOL_DISPLAY_NAMES } from 'constants/aol/aol'

const FacetOption = ({
  parameterName,
  name,
  value,
  selected,
  handleFacetOptionClick,
  disabled = false
}) => {
  const handleOnClick = () => {
    if (!disabled) {
      handleFacetOptionClick(parameterName, value, !selected, disabled)
    }
  }

  const label = parameterName === 'aol'
    ? (AOL_DISPLAY_NAMES[value] || name)
    : name

  return (
    <Link
      href={null}
      label={label}
      checkboxValue={(selected | 0) * 2}
      onClick={handleOnClick}
      disabled={disabled}
    />
  )
}

export default FacetOption

const Link = ({ href, checkboxValue, label, onClick, disabled }) => {
  const [clamped, setClamped] = useState(false)

  return (
    <TealToolTip
      title={disabled
        ? 'You do not have access to this as part of your subscription.'
        : clamped
          ? label
          : ''}
      placement='right'
    >
      <div {...{ onClick }}>
        <a
          className={cx(
            'flex items-center w-100  black no-underline focus-outline-0 mt2 f6',
            { 'pointer filter-link': !disabled, 'not-allowed o-30': disabled }
          )}
          href={disabled ? '' : href}
          data-event-category='Search'
          data-event-action={checkboxValue > 0 ? 'Add Filter' : 'Remove Filter'}
          data-event-label={label}
          disabled={disabled}
        >
          <Icon
            className={cx('filter-checkbox-icon mr4', { 'dark-sea-green-3': checkboxValue === 2 })}
            name={{
              'icon-checkbox-blank-thin-outline': checkboxValue === 0,
              'icon-checkbox-marked': checkboxValue === 2
            }}
          />
          <Truncate
            trimWhitespace
            width={192}
            onTruncate={(isClamped) => setClamped(isClamped)}
          >
            {label}
          </Truncate>
        </a>
      </div>
    </TealToolTip>
  )
}
